import { assert } from '@varos/util-typescript';
import { AssistantLoaderBaseConfig } from '../../../base';
import { ThreadOverviewLoader } from './threadOverviewInterface';
import { useMemo } from 'react';

export function createThreadOverviewLoader(
    config: AssistantLoaderBaseConfig
): ThreadOverviewLoader {
    const {
        repository: { thread: threadRepository },
    } = config;
    return {
        useLoad(context, props) {
            const threadQuery = threadRepository.useFind(
                context,
                {
                    limit: 5,
                },
                {
                    suspense: true,
                }
            );
            assert(threadQuery.status === 'success', 'expected suspense');

            const open = useMemo(() => {
                const [mostRecent] = threadQuery.data;
                if (!mostRecent) {
                    return null;
                }
                if (mostRecent.status !== 'open') {
                    return null;
                }
                return mostRecent;
            }, [threadQuery.data]);

            return {
                recent: threadQuery.data,
                pending: threadQuery.data.filter((thread) => thread.status === 'open'),
                completed: threadQuery.data.filter(
                    (thread) => thread.status === 'closed'
                ),
                open,
            };
        },
    };
}
